module.exports = __webpack_public_path__ + "img/checked.4d057a45.png";